import type { Action } from 'svelte/action';

/**
 * Adds subtle 3D tilt on mouse move. Usage: <div use:tilt>
 */
export const tilt: Action<HTMLElement, { max?: number } | undefined> = (node, params) => {
    const max = params?.max ?? 4;

    function onMove(e: MouseEvent) {
        const rect = node.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;
        const cx = rect.width / 2;
        const cy = rect.height / 2;
        const rotX = ((y - cy) / cy) * -max;
        const rotY = ((x - cx) / cx) * max;
        node.style.transform = `perspective(1000px) rotateX(${rotX}deg) rotateY(${rotY}deg) translateY(-2px)`;
    }
    function onLeave() {
        node.style.transform = '';
    }

    node.addEventListener('mousemove', onMove);
    node.addEventListener('mouseleave', onLeave);

    return {
        destroy() {
            node.removeEventListener('mousemove', onMove);
            node.removeEventListener('mouseleave', onLeave);
        }
    };
};
